import React from 'react'

export default function useSuspendedLoadingState(
  initialIsLoading,
  delay = 200
) {
  const actualIsLoading = React.useRef()
  const timeoutRef = React.useRef()
  const [delayedIsLoading, setDelayedIsLoading] = React.useState(
    initialIsLoading
  )

  function setIsLoading(isLoading) {
    if (actualIsLoading.current && !isLoading) {
      clearTimeout(timeoutRef.current)
      setDelayedIsLoading(false)
    }
    if (!actualIsLoading.current && isLoading) {
      timeoutRef.current = setTimeout(
        function useSuspendedLoadingStateCallback() {
          setDelayedIsLoading(true)
        },
        delay
      )
    }
    actualIsLoading.current = isLoading
  }

  React.useEffect(
    () => setIsLoading(initialIsLoading),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  ) // once

  return [delayedIsLoading, setIsLoading]
}
